import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { dateFormat } from 'src/app/app.constants';

@Pipe({
  name: 'moment',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  transform(date: string, format = dateFormat): string {
    return moment(date).format(format);
  }
}
